<template>
  <div class="navbar">
    <!-- Desktop Menu -->
    <el-menu
        :default-active="activeIndex"
        class="desktop-menu"
        mode="horizontal"
        @select="handleSelect"
    >
      <div class="logo">
        <img src="../assets/logo/logos.jpg" alt="Logo" />
      </div>
      <el-menu-item index="1" @click="handleMainMenuClick('/')">首页</el-menu-item>
      <el-sub-menu
          index="2"
          @click.native="handleMainMenuClick('/Product')"
      >
        <template #title>
          <span :class="{ 'main-menu-active': activeIndex === '2' }">产品中心</span>
        </template>
        <template v-for="(category, catIndex) in products" :key="'cat-'+catIndex">
          <el-sub-menu v-if="category.children" :index="'2-'+(catIndex+1)">
            <template #title>{{ category.name }}</template>
            <el-menu-item
                v-for="(product, prodIndex) in category.children"
                :key="'prod-'+prodIndex"
                :index="'2-'+(catIndex+1)+'-'+(prodIndex+1)"
                @click="goToProductDetail(product.id)"
            >
              {{ product.id }}
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item
              v-else
              :index="'2-'+(catIndex+1)"
              @click="handleProductClick(category)"
          >
            {{ category.name }}
          </el-menu-item>
        </template>
      </el-sub-menu>
      <el-sub-menu
          index="3"
          @click.native="handleMainMenuClick('/CaseShow')"
      >
        <template #title>
          <span :class="{ 'main-menu-active': activeIndex === '3' }">案例展示</span>
        </template>
        <template v-for="(category, catIndex) in cases" :key="'cat-'+catIndex">
          <el-sub-menu v-if="category.children" :index="'3-'+(catIndex+1)">
            <template #title>{{ category.name }}</template>
            <el-menu-item
                v-for="(caseItem, caseIndex) in category.children"
                :key="'case-'+caseIndex"
                :index="'3-'+(catIndex+1)+'-'+(caseIndex+1)"
                @click="handleCaseClick(caseItem)"
            >
              {{ caseItem.name }}
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item
              v-else
              :index="'3-'+(catIndex+1)"
              @click="handleCaseClick(category)"
          >
            {{ category.name }}
          </el-menu-item>
        </template>
      </el-sub-menu>
      <el-menu-item index="6" @click="handleMainMenuClick('/SolutionsHome')">解决方案</el-menu-item>
      <el-menu-item index="5" @click="handleMainMenuClick('/support')">联系与支持</el-menu-item>
      <el-menu-item index="7" @click="handleMainMenuClick('/about')">关于我们</el-menu-item>
    </el-menu>

    <div class="logo2">
      <img src="../assets/logo/logos.jpg" alt="Logo" />
    </div>

    <!-- Mobile Hamburger Button -->
    <img src="../Homeioc/menu-ioc.png"
         class="hamburger-btn"
         @click="toggleMenu"
         icon="el-icon-menu"/>

    <!-- Mobile Menu -->
    <el-collapse-transition>
      <el-menu
          v-if="isMenuOpen"
          class="mobile-menu"
          :default-active="activeIndex"
          mode="vertical"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          @select="handleSelect"
      >
        <el-menu-item index="1" @click="handleMainMenuClick('/')">首页</el-menu-item>
        <el-sub-menu
            index="2"
            @click.native="handleMainMenuClick('/Product')"
        >
          <template #title>
            <span :class="{ 'main-menu-active': activeIndex === '2' }">产品中心</span>
          </template>
          <template v-for="(category, catIndex) in products" :key="'m-cat-'+catIndex">
            <el-sub-menu v-if="category.children" :index="'2-'+(catIndex+1)">
              <template #title>{{ category.name }}</template>
              <el-menu-item
                  v-for="(product, prodIndex) in category.children"
                  :key="'m-prod-'+prodIndex"
                  :index="'2-'+(catIndex+1)+'-'+(prodIndex+1)"
                  @click="handleProductClick(product)"
              >
                {{ product.name }}
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item
                v-else
                :index="'2-'+(catIndex+1)"
                @click="handleProductClick(category)"
            >
              {{ category.name }}
            </el-menu-item>
          </template>
        </el-sub-menu>

        <el-sub-menu
            index="3"
            @click.native="handleMainMenuClick('/CaseShow')"
        >
          <template #title>
            <span :class="{ 'main-menu-active': activeIndex === '3' }">案例展示</span>
          </template>
          <template v-for="(category, catIndex) in cases" :key="'m-case-'+catIndex">
            <el-sub-menu v-if="category.children" :index="'3-'+(catIndex+3)">
              <template #title>{{ category.name }}</template>
              <el-menu-item
                  v-for="(caseItem, caseIndex) in category.children"
                  :key="'m-ex-'+caseIndex"
                  :index="'3-'+(catIndex+3)+'-'+(caseIndex+3)"
                  @click="handleCaseClick(caseItem)"
              >
                {{ caseItem.name }}
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item
                v-else
                :index="'3-'+(catIndex+1)"
                @click="handleCaseClick(category)"
            >
              {{ category.name }}
            </el-menu-item>
          </template>
        </el-sub-menu>
        <el-menu-item index="4" @click="handleMainMenuClick('/SolutionsHome')">解决方案</el-menu-item>
        <el-menu-item index="5" @click="handleMainMenuClick('/support')">联系与支持</el-menu-item>
        <el-menu-item index="6" @click="handleMainMenuClick('/about')">关于我们</el-menu-item>
      </el-menu>
    </el-collapse-transition>
  </div>
</template>

<script>
import server from "@/api/server"
import serverApi from "@/api/server";

export default {
  name: 'Navbar',
  data() {
    return {
      isMenuOpen: false,
      activeIndex: '1',
      solutions: [],
      products: [],
      cases: []
    };
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        this.updateActiveIndex(to.path, to.query);
      }
    }
  },
  created() {
    server.Solutions().then(res => {
      this.solutions = res.data.data;
    });
    this.productClassName();
  },
  methods: {
    productClassName() {
      serverApi.getProductClassNameList().then(res => {
        this.products = res.data.data;
      });
      server.getCase().then(res => {
        this.cases = res.data.data;
      });
    },
    updateActiveIndex(path, query) {
      const routeMap = {
        '/': '1',
        '/SolutionsHome': '6',
        '/Product': '2',
        '/CaseShow': '3',
        '/support': '5',
        '/about': '7'
      };

      // 使用更严格的路由匹配
      if (path === '/Product' || path.startsWith('/Product/') || /product/i.test(path)) {
        this.activeIndex = '2';
        return;
      }

      if (path === '/CaseShow' || path.startsWith('/CaseShow/') || /case/i.test(path)) {
        this.activeIndex = '3';
        return;
      }

      if (path === '/SolutionsHome' || path.startsWith('/SolutionsHome/') || /solution/i.test(path)) {
        this.activeIndex = '6';
        return;
      }

      // 直接匹配的路由
      if (routeMap[path]) {
        this.activeIndex = routeMap[path];
        return;
      }

      this.activeIndex = '1';
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleMainMenuClick(path) {
      this.$router.push(path);
      this.isMenuOpen = false;
      // 立即更新activeIndex而不是等待路由监听
      this.updateActiveIndex(path, this.$route.query);
    },
    handleProductClick(product) {
      this.$router.push({
        path: '/Product',
        query: {
          id: product.id
        }
      });
      this.isMenuOpen = false;
      this.activeIndex = '2';
    },
    handleCaseClick(caseItem) {
      this.$router.push({
        path: '/CaseShow',
        query: {
          id: caseItem.id,
          category: caseItem.category || caseItem.name,
          industry: caseItem.industry || 'general'
        }
      });
      this.isMenuOpen = false;
      this.activeIndex = '3';
    },
    handleSelect(key) {
      this.activeIndex = key;
      this.isMenuOpen = false;
    }
  }
};
</script>
<style scoped>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1px;
  background-color: #ffffff;
  font-weight: 700;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.logo img {
  position: relative;
  top: 7px;
  left: 20px;
  height: 70px;
  width: 400px;
  transform: translate(-180px, 0px);
}

.logo2 img {
  display: none;
  height: 70px;
  width: 350px;
  transform: translate(-15px, 0px);
}

.desktop-menu {
  display: flex;
  justify-content: center;
  flex-grow: 10;
  font-size: 50px;
  height: 100px;
}

.desktop-menu .el-menu-item:hover,
.desktop-menu .el-sub-menu__title:hover {
  background-color: transparent !important;
}

.hamburger-btn {
  transform: translate(-20px, 10px);
  display: none;
  width: 40px;
  height: 30px;
  cursor: pointer;
}

.mobile-menu {
  transform: translate(0px, 20px);
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.mobile-menu .el-menu-item:hover,
.mobile-menu .el-sub-menu__title:hover {
  background-color: transparent !important;
}

.el-collapse-transition {
  font-weight: 700;
}

/* 主菜单高亮样式 */
.main-menu-active {
  color: #409EFF !important;
  font-weight: bold;
}

.desktop-menu .el-sub-menu.is-active .el-sub-menu__title .main-menu-active,
.mobile-menu .el-sub-menu.is-active .el-sub-menu__title .main-menu-active {
  color: #409EFF !important;
}

@media (max-width: 992px) {
  .desktop-menu {
    font-size: 40px;
  }

  .logo img {
    width: 350px;
    transform: translate(-150px, 0px);
  }
}

@media (max-width: 768px) {
  .desktop-menu {
    font-size: 35px;
  }
}

@media (max-width: 576px) {
  .desktop-menu {
    display: none;
  }

  .logo2 img {
    display: block;
  }

  .logo img {
    display: none;
  }

  .hamburger-btn {
    display: block;
  }

  .el-menu-item, .el-sub-menu__title {
    padding: 0 20px;
  }
}
</style>
